// @flow
import { connect } from 'react-redux';
import { injectIntl } from 'react-intl';
import { compose } from 'redux';

// Components
import SidebarButton from './SidebarButton';

// Actions
import { gtmUserEventSidebarButton } from 'store/reducers/gtm/actions';

export default compose(
  injectIntl,
  connect(
    null,
    { gtmUserEventSidebarButton }
  )
)(SidebarButton);



// WEBPACK FOOTER //
// ./src/components/pages/User/Sidebar/SidebarButton/SidebarButtonContainer.js